import { formatDate } from "utils/business/formatDate";

export const filterFormatDate = (startDate: Date, endDate: Date): string => {
  const formatStartDate = formatDate(startDate);
  const formatEndDate = formatDate(endDate);
  return `${formatStartDate}_${formatEndDate}`;
};
